<div class="row">
  <div class="medium-6 columns">
    <div class="row">
      <div class="small-4 columns">
        <label>Firm Name</label>
      </div>
      <div class="small-8 columns">
        <input type="text" [(ngModel)]="newFirmObj.firmName" placeholder="Firm Name">
      </div>
    </div>
    <div class="row">
      <div class="small-4 columns">
        <label>First Name</label>
      </div>
      <div class="small-8 columns">
        <input type="text" [(ngModel)]="newFirmObj.firstName" placeholder="First Name">
      </div>
    </div>
    <div class="row">
      <div class="small-4 columns">
        <label>Last Name</label>
      </div>
      <div class="small-8 columns">
        <input type="text" [(ngModel)]="newFirmObj.lastName" placeholder="Last Name">
      </div>
    </div>
    <div class="row">
      <div class="small-4 columns">
        <label>Email</label>
      </div>
      <div class="small-8 columns">
        <input type="text" [(ngModel)]="newFirmObj.email" placeholder="Email">
        <div class="error" *ngIf="newFirmObj.email && !isValidEmail(newFirmObj.email)">Please check email format</div>
      </div>
    </div>
    <div class="row">
      <div class="small-4 columns">
        <label>Website</label>
      </div>
      <div class="small-8 columns">
        <input type="text" [(ngModel)]="newFirmObj.website" placeholder="Website">
      </div>
    </div>
    <div class="row">
      <div class="small-4 columns">
        <label>Org</label>
      </div>
      <div class="small-8 columns">
        <input type="text" [(ngModel)]="newFirmObj.orgId" placeholder="Org">
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="medium-12 columns">
    <button class="small button float-right" (click)="createFirm()">CREATE</button>
  </div>
</div>
